export const colors = {
  PURPLE: '#392348',
  YELLOW: '#e3a43d',
  RED: '#ad262f',
  BLUE: 'rgba(139,200,246,.565)',
};
